export const ChevronLeftIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="7"
    height="12"
    viewBox="0 0 7 12"
    fill="none"
    {...props}
  >
    <path d="M6 1L1 6L6 11" stroke="currentColor" />
  </svg>
)
